module.exports = __webpack_public_path__ + "static/media/3.e55a92a7.png";